// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"63da382f","346":"2d869e09","548":"97304877","695":"ff1664bf","899":"8dec926f","911":"a7974688"}[chunkId] + ".chunk.js";
};